import { activateAccountRequest } from 'application/redux/actions/common/account_details'
import { connect } from 'react-redux'
import ActivationModeServiceProvider from './component'

const mapStateToProps = (state) => ({
    agbAndDatenschutzAccepted: state.common.agbDatenschutz.isAccepted,
    checkedAccountId: state.common.agbDatenschutz.accountId,
    activateRequest: state.common.accountDetails.activate.request,
})

const mapDispatchToProps = dispatch => ({
    activateAccount: (accountId, payload) => {dispatch(activateAccountRequest(accountId, payload))}
})

export default connect(mapStateToProps, mapDispatchToProps)(ActivationModeServiceProvider)
